import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import WMSIntroImage from '../../../../../Assets/wms_intro.jpg'

const heroImage =WMSIntroImage;

const partnerLogo =
  'https://ik.imagekit.io/kqumni8l2/inforAlliance%20PatnerLogo.png?updatedAt=1737438400542';

const Intro = () => {
  return (
    <section
      className="relative flex min-h-[70vh] items-center overflow-hidden px-4 py-20 sm:px-6 lg:px-8"
      style={{
        backgroundImage: `linear-gradient(
        rgba(5, 18, 32, 0.82),
        rgba(5, 18, 32, 0.82)
      ), url(${heroImage})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              
            }}
    >
      <div
        className="absolute inset-x-0 bottom-0 h-36"
        style={{
          background:
            'linear-gradient(180deg, rgba(5, 18, 32, 0) 0%, rgba(5, 18, 32, 0.72) 100%)',
        }}
      />

      <div className="relative z-10 mx-auto w-full max-w-7xl">
        <div className="max-w-3xl">
          {/* <div
            className="mb-6 inline-flex rounded-lg border px-4 py-2 text-sm font-bold"
            style={{
              backgroundColor: 'rgba(255, 255, 255, 0.12)',
              borderColor: 'rgba(255, 255, 255, 0.24)',
              color: '#FFFFFF',
              backdropFilter: 'blur(12px)',
            }}
          >
            Infor LN ERP Solutions
          </div> */}

          <h1
            className="text-2xl font-bold leading-tight sm:text-3xl md:text-4xl"
            style={{ color: '#FFFFFF' }}
          >
            
Optimize Warehouse Efficiency with Infor WMS
Advanced, Scalable, and Intelligent Warehouse Management
          </h1>

          <p
            className="mt-6 max-w-xl text-base leading-8 sm:text-lg"
            style={{ color: '#ffffff' }}
          >
           Smarter, faster, and more accurate warehouse operations.
          </p>

          <div className="mt-8 flex flex-col gap-4 sm:flex-row sm:items-center">
            <Link to="/contact" onClick={() => window.scrollTo(0, 0)}>
              <button
                className="group inline-flex w-full items-center justify-center gap-3 px-4 py-4 text-base font-bold transition duration-300 hover:-translate-y-1 sm:w-auto"
                style={{
                  backgroundColor: '#D81820',
                  color: '#FFFFFF',
                  boxShadow: '0 18px 42px rgba(249, 115, 22, 0.34)',
                }}
              >
                Talk to an Expert
                <ArrowRight className="h-5 w-5 transition duration-300 group-hover:translate-x-1" />
              </button>
            </Link>

            {/* <div
              className="flex w-full items-center justify-center rounded-lg px-4 py-3 sm:w-auto"

            >
              <img
                src={partnerLogo}
                alt="Infor Alliance Partner"
                className="h-14 w-40 object-contain"
              />
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Intro;
